import React from 'react'
import type { OverlayTriggerProps } from '../OverlayTrigger'
import type { TooltipProps } from '../Tooltip'
import { Tooltip, TooltipIconOnlyButton } from '../Tooltip/Tooltip'

export const FormFieldTooltip: React.FC<
  Omit<OverlayTriggerProps & TooltipProps, 'children'>
> = (props) => {
  return (
    <Tooltip trackAriaExpanded {...props}>
      <TooltipIconOnlyButton data-qa="form-field-tooltip-icon" />
    </Tooltip>
  )
}
